<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="0"></el-option>
                            <el-option label="用户名" :value="1"></el-option>
                            <el-option label="负责人手机" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.provinceCode" placeholder="请选择省份" size="small" @change="getCityList">
                        <el-option v-for="(item,index) in province" :key="index" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.cityCode" placeholder="请选择城市" size="small">
                        <el-option v-for="(item,index) in city" :key="index" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.claimStatus" placeholder="请选择" size="small">
                        <el-option label="仅看待审核的" :value="1"></el-option>
                        <el-option label="仅看已通过的" :value="2"></el-option>
                        <el-option label="仅看已拒绝的" :value="3"></el-option>
                        <el-option label="不限制审核状态" value=""></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="claimStatus" label="审核状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.claimStatus == 0" type="info" size="mini">流程中</el-tag>
                        <el-tag v-else-if="scope.row.claimStatus == 1" type="warning" size="mini">待审核</el-tag>
                        <el-tag v-else-if="scope.row.claimStatus == 2" type="success" size="mini">已通过</el-tag>
                        <el-tag v-else-if="scope.row.claimStatus == 3" type="danger" size="mini">已拒绝</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="userType" label="身份" >
                    <template slot-scope="scope">
                        {{userType.get(scope.row.userType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="userName" label="用户名" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="phone" label="负责人手机" min-width="110"></el-table-column>
                <el-table-column prop="provinceName" label="省份"></el-table-column>
                <el-table-column prop="cityName" label="城市"></el-table-column>
                <el-table-column prop="registerTime" label="注册时间" min-width="150"></el-table-column>
                <el-table-column prop="createTime" label="提交审核时间" min-width="150"></el-table-column>
                <el-table-column prop="opUserName" label="审核人"></el-table-column>
                <el-table-column prop="opTime" label="审核时间" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="170">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/userClaim/operation')"
                            type="text"
                            size="small"
                            icon="el-icon-coordinate"
                            @click="view(scope.row.id)"
                            >审核</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="baseInfo(scope.row)"
                            >管理用户信息</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {fetchProvince,fetchCityList} from '@/assets/js/commonApi'
const defaultParams = {
    pageNo: 1,
    queryType: 0,
    queryValue: '',
    provinceCode: '',
    cityCode: '',
    claimStatus: 1
}

export default {
    props:{
        type:{
            type:Number,
            default:1
        }
    },
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                queryType: parseInt(this.$route.query.queryType || 0),
                queryValue: this.$route.query.queryValue || '',
                provinceCode: this.$route.query.provinceCode ? parseInt(this.$route.query.provinceCode) : '',
                cityCode: this.$route.query.cityCode ? parseInt(this.$route.query.cityCode) : '',
                claimStatus: parseInt(this.$route.query.claimStatus || 1)
            },
            listLoading: false, 
            province:[],
            city:[]
        }
    },
    computed:{
        userType(){
            return new Map([
                [1,'粉丝'],
                [2,'艺人'],
                [3,'场地'],
                [4,'赞助商'],
                [5,'厂牌']
            ])
        }
    },
    created(){
        this.getProvince();
        if( this.params.provinceCode ){
            this.getCityList(this.params.cityCode);
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取所有省份
        async getProvince(){
            const res = await fetchProvince({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.province = result;
            }
        },
        //获取城市
        async getCityList(cityCode){
            const res = await fetchCityList(this.params.provinceCode).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.city = result;
            }
            this.params.cityCode = cityCode || '';
        },
         //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/userClaim/pageList",
                method: "POST",
                data: {
                    ...this.params,
                    type: this.type
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //管理用户信息
        baseInfo(item){
            const _userId = item.userId, _userType = item.userType;
            let _url = '';
            if(_userType == 2){
                _url = '/user/artist/edit/baseInfo/'+_userId;
            }
            if(_userType == 3){
                _url = '/user/site/edit/baseInfo/'+_userId;
            }
            if(_userType == 5){
                _url = '/user/brand/edit/baseInfo/'+_userId;
            }
            this.$router.push({
                path:_url,
                query:{
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                }
            })
        },
        //审核详情
        view(id){
            let _url = this.type == 1 ? '/user/userClaim/' : '/user/userAuth/';
            _url += id;
            this.$router.push({
                path:_url,
                query:{
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                }
            })
        }
    }
}
</script>